import axios from 'axios';
import config from '../../config/configuration';

const client = axios.create({
  baseURL: config.BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    // Add any other required headers here
  },
});

export default client;
